<template>
  <div>
  <el-container>
  <el-header>
     <div class="appname">房贷计算器</div>
     <img src="../assets/logo.png" class="logo">
    </img>

    <div class="header-space"></div>


    <div>扫码下载App</div>
    <img src="../assets/qrcode.png" class="qrcode">
    </img>
    
  </el-header>


  <el-main>
    <div class="main-background">
    
    </div>
 
  </el-main>

  <el-footer>
   <a href="https://beian.miit.gov.cn/">京ICP备18015688号</a>
    <div>&nbsp|&nbsp</div>
    <a href="http://www.yangshuyao.top/examples/aaa.html">用户隐私协议</a>
  </el-footer>

</el-container>


  </div>
  

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo{
  width:40px;
  height:40px;
  border-radius:5px;
margin-left:10px;
}

a{
  text-decoration:none
}

.el-header, .el-footer {
    background-color: #ffffff;
    color: #333;
    text-align: left;
    height:100px !important;
    width:100%;
    display:flex;
    flex-direction:row;
    align-items:center;
    
  }

  .el-footer{
    background-color: #eeeeee;
    color: #333;
    text-align: center;
    height:100px !important;
    width:100%;
    display:flex;
    flex-direction:row;
    align-items:center;

    justify-content:center;
  }


.header-space{
  flex:1;
}

  .qrcode{
    width:80px;
  height:80px;
margin-right:20px;
margin-left:5px;

  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    color: #333;
    text-align: left;
    height:500px;
    width:100%;
    overflow:hidden;
  }

  .main-background{
     height:499px;
    width:100%;
    background:url("../assets/background.png") no-repeat center;
    background-size:cover;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue